import { gql } from "@apollo/client";

export default gql`
  fragment ComplianceProgramTarget on UserNode {
    id
    name
    avatar
    organizationSpecificInfo {
      startDate
    }
    primaryManager {
      id
      name
    }
    teamsList {
      id
      title
    }
  }
`;
